import { useWorkspaces } from "@/api/workspaces.store";

/**
 *
 */
export function getRouteToWorkspace(workspace: { id: number }) {
  const workspaceId = workspace.id;
  const workspaces = useWorkspaces().workspaces;
  const workspaceEntry = workspaces?.[workspaceId];

  if (workspaceEntry?.isPersonal) {
    return {
      name: "personal-workspace"
    };
  } else {
    return {
      name: "team",
      params: {
        organizationSlug: workspaceEntry?.organizationSlug,
        teamSlug: workspaceEntry?.slug
      }
    };
  }
}

/**
 * Returns a vue router route target the selected folder
 */
export function getRouteToFolder(folder: {
  workspace: number;
  slug?: string;
  id?: number;
}) {
  const workspaceId = folder.workspace;
  const workspaces = useWorkspaces().workspaces;
  const workspace = workspaces?.[workspaceId];
  let folderSlug = folder.slug;

  if (!folderSlug) {
    const workspaceFolders = workspace?.folders || [];
    const folderData = workspaceFolders.find((f) => f.id == folder.id);
    folderSlug = folderData?.slug;
  }

  if (workspace == null) {
    throw new Error("Folder has no workspace");
  }

  if (workspace.isPersonal) {
    return {
      name: "personal-workspace-folder",
      params: {
        folderSlug
      }
    };
  } else {
    return {
      name: "team-folder",
      params: {
        organizationSlug: workspace.organizationSlug,
        teamSlug: workspace.slug,
        folderSlug
      }
    };
  }
}

export function getRouteToModel(model: {
  id?: number | string;
  workspace?: number;
  folderSlug?: string;
  folder?: number;
}) {
  const workspaceId = model.workspace;

  const workspaces = useWorkspaces().workspaces;

  const workspace = workspaceId != null ? workspaces[workspaceId] : undefined;
  if (workspace == null) {
    console.warn("workspace is null", workspaces, workspaceId);
    throw new Error("Workspace is null.");
  }

  let folderSlug = model.folderSlug;
  if (folderSlug == null) {
    const folderId = model.folder;
    if (folderId == null) {
      throw new Error("Folder is null.");
    }

    const workspaceFolders = workspace.folders ?? [];
    const folder = workspaceFolders.find((f) => f.id == folderId);
    folderSlug = folder?.slug;
  }

  if (workspace.isPersonal) {
    return {
      name: "personal-workspace-model-info",
      params: {
        folderSlug,
        modelId: model.id
      }
    };
  } else {
    return {
      name: "team-model-info",
      params: {
        organizationSlug: workspace.organizationSlug,
        teamSlug: workspace.slug,
        folderSlug,
        modelId: model.id
      }
    };
  }
}

export function getRouteToModelData(model: {
  id?: number | string;
  workspace?: number;
}) {
  const modelRoute = getRouteToModel(model);
  if (modelRoute.name.includes("team")) {
    modelRoute.name = "team-model";
  } else {
    modelRoute.name = "personal-workspace-model";
  }

  return modelRoute;
}
